import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    GROUP_MULTICODES: gql`
      query GroupMulticodes {
        groupMulticodes {
          code
          codekey
          linkedGroups {
            groupkey
            title
          }
          registration
        }
      }
    `,
    GROUPS: gql`
      query Groups {
        groups {
          groupkey
          title
        }
      }
    `,
    USERS: gql`
      query Users {
        users {
          userkey
          username
          firstname
          lastname
          email
          permissions {
            key
            value
          }
        }
      }
    `,
    SITE_ADMINS: gql`
      query SiteAdmins {
        siteAdmins {
          userkey
          username
          firstname
          lastname
          permissions {
            key
            value
          }
        }
      }
    `,
    SITE_ADMINS_BY_ACCESS: gql`
      query SiteAdminsByAccess($request: [AdminPermissionInput]) {
        siteAdminsByAccess(request: $request) {
          userkey
          username
          firstname
          lastname
          permissions {
            key
            value
          }
        }
      }
    `,
    SITE_SETTINGS: gql`
      query SiteSettings {
        siteSettings {
          flags {
            requireEmailVerification
            allowUserRegistration
            allowLinkedAccounts
          }
          options {
            notification
            emailOptions {
              admin
              expiry
              content
              permissions
              assessment
            }
            locale
            timezone
          }
        }
      }
    `,
    // * Profile Fields
    PROFILE_DATA: gql`
      query ProfileData {
        profileData {
          profilekey
          title
          description
        }
      }
    `,
    DOMAIN_PROFILES: gql`
      query DomainProfiles {
        domainProfiles {
          profilekey
          title
          description
          position
          required
          global
          active
        }
      }
    `,
    AVAILABLE_PROFILES: gql`
      query AvailableProfiles {
        availableProfiles {
          profilekey
          title
          description
        }
      }
    `,
    PAYMENT_SETTINGS: gql`
      query PaymentSettings {
        paymentSettings {
          clientId
          currency
        }
      }
    `,
    CURRENCY_CODES: gql`
      query CurrencyCodes {
        currencyCodes
      }
    `,
    CATEGORIES: gql`
      query Categories {
        categories {
          categorykey
          domainkey
          position
          assets {
            label
            type
            required
          }
        }
      }
    `,
    CATEGORY_ITEMS: gql`
      query CategoryItems($categorykey: Int!) {
        categoryItems(categorykey: $categorykey) {
          itemkey
          categorykey
          position
          assets {
            label
          }
        }
      }
    `,
    ITEM_GROUPS: gql`
      query ItemGroups($itemkey: Int!) {
        itemGroups(itemkey: $itemkey) {
          itemkey
          groupkey
        }
      }
    `
  },
  Mutation: {
    CREATE_GROUP_MULTICODE: gql`
      mutation CreateGroupMulticode($input: CreateGroupMulticodeInput!) {
        createGroupMulticode(input: $input)
      }
    `,
    UPDATE_GROUP_MULTICODE: gql`
      mutation UpdateGroupMulticode($input: UpdateGroupMulticodeInput!) {
        updateGroupMulticode(input: $input)
      }
    `,
    DELETE_MULTICODE: gql`
      mutation DeleteMulticode($code: String!, $codekey: Int!) {
        deleteMulticode(code: $code, codekey: $codekey)
      }
    `,
    UPDATE_ADMIN_SETTINGS: gql`
      mutation UpdateAdminSettings($input: UpdateAdminSettingsInput!) {
        updateAdminSettings(input: $input) {
          userkey
          username
          firstname
          lastname
          permissions {
            key
            value
          }
        }
      }
    `,
    SET_SITE_SETTINGS: gql`
      mutation SetSiteSettings($input: SetSiteSettingsInput!) {
        setSiteSettings(input: $input)
      }
    `,
    SET_DOMAIN_PROFILE_ACTIVE: gql`
      mutation SetDomainProfileActive($profilekey: Int!, $active: Boolean!) {
        setDomainProfileActive(profilekey: $profilekey, active: $active) {
          profilekey
          position
          required
        }
      }
    `,
    UPDATE_DOMAIN_PROFILE: gql`
      mutation UpdateDomainProfile(
        $profilekey: Int!
        $input: DomainProfileInput!
      ) {
        updateDomainProfile(profilekey: $profilekey, input: $input) {
          profilekey
          position
          required
          # active
        }
      }
    `,
    UPSERT_PAYMENT_SETTINGS: gql`
      mutation UpsertPaymentSettings($input: PaymentSettingsInput!) {
        upsertPaymentSettings(input: $input) {
          clientId
          currency
        }
      }
    `,
    CREATE_CATEGORY: gql`
      mutation CreateCategory($input: CategoryInput) {
        createCategory(input: $input)
      }
    `,
    UPDATE_CATEGORY: gql`
      mutation UpdateCategory($categorykey: Int!, $input: CategoryInput) {
        updateCategory(categorykey: $categorykey, input: $input) {
          categorykey
          domainkey
          position
          assets {
            label
            type
            required
          }
        }
      }
    `,
    DELETE_CATEGORY: gql`
      mutation DeleteCategory($categorykey: Int!) {
        deleteCategory(categorykey: $categorykey)
      }
    `,
    CREATE_ITEM: gql`
      mutation CreateItem($categorykey: Int!, $input: CategoryItemInput) {
        createItem(categorykey: $categorykey, input: $input)
      }
    `,
    UPDATE_ITEM: gql`
      mutation UpdateItem($itemkey: Int!, $input: CategoryItemInput) {
        updateItem(itemkey: $itemkey, input: $input) {
          itemkey
          categorykey
          position
          assets {
            label
          }
        }
      }
    `,
    DELETE_ITEM: gql`
      mutation DeleteItem($itemkey: Int!) {
        deleteItem(itemkey: $itemkey)
      }
    `,
    ADD_ITEM_GROUP: gql`
      mutation AddItemGroup($itemkey: Int!, $groupkey: Int!) {
        addItemGroup(itemkey: $itemkey, groupkey: $groupkey)
      }
    `,
    DELETE_ITEM_GROUP: gql`
      mutation DeleteItemGroup($itemkey: Int!, $groupkey: Int!) {
        deleteItemGroup(itemkey: $itemkey, groupkey: $groupkey)
      }
    `
  }
};

export default GraphQL;
